export default "__VITE_ASSET__42c2fa70__"